// extracted by mini-css-extract-plugin
export var aboutMax = "HistorySection-module--aboutMax--bb79e";
export var grid = "HistorySection-module--grid--78827";
export var image = "HistorySection-module--image--ebd16";
export var section = "HistorySection-module--section--84e01";